if (!customElements.get('vip-cart-messaging')) {
  customElements.define(
    'vip-cart-messaging',
    class VipCartMessaging extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-vip-zones-config]').textContent);
        this.messageEl = this.querySelector('[data-vip-cart-message]');
        this.render();
        this.boundZipChange = (event) => this.render(event.detail && event.detail.zip);
        document.addEventListener('vip:zip:change', this.boundZipChange);
      }

      disconnectedCallback() {
        document.removeEventListener('vip:zip:change', this.boundZipChange);
      }

      savedZip() {
        try {
          return localStorage.getItem('vip:delivery-zip');
        } catch {
          return null;
        }
      }

      formatMoney(amount) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.config.currency || 'USD',
          minimumFractionDigits: Number(amount) % 1 === 0 ? 0 : 2,
        }).format(Number(amount));
      }

      render(zipOverride) {
        const zip = zipOverride || this.savedZip();
        if (!zip) {
          this.hidden = true;
          return;
        }
        const zone = this.config.zones.find((z) => (z.zips || []).includes(zip));
        if (!zone) {
          this.hidden = true;
          return;
        }
        const totalDollars = parseInt(this.dataset.cartTotal, 10) / 100;
        const fill = (template, values) =>
          Object.entries(values).reduce((out, [key, value]) => out.replace(`[${key}]`, value), template);

        let text = null;
        const minOrder = Number(zone.minOrder || 0);
        const freeThreshold = zone.freeThreshold != null ? Number(zone.freeThreshold) : null;

        if (minOrder > 0 && totalDollars < minOrder) {
          text = fill(this.config.strings.minAway, {
            amount: this.formatMoney(minOrder - totalDollars),
            min: this.formatMoney(minOrder),
            zip,
          });
        } else if (freeThreshold != null && totalDollars >= freeThreshold) {
          text = fill(this.config.strings.freeReached, { zip });
        } else if (freeThreshold != null) {
          text = fill(this.config.strings.freeAway, {
            amount: this.formatMoney(freeThreshold - totalDollars),
            zip,
          });
        } else if (Number(zone.fee) > 0) {
          text = fill(this.config.strings.feeLine, { fee: this.formatMoney(zone.fee), zip });
        }

        if (!text) {
          this.hidden = true;
          return;
        }
        this.messageEl.textContent = text;
        this.hidden = false;
      }
    }
  );
}
